const AmyPosition = {
  Center: 'center',
  BottomRight: 'bottomRight',
  BottomCenter: 'bottomCenter',
};

export default AmyPosition;
